import clsx from "clsx";
import React from "react";
import ReactHtmlParser from "react-html-parser";

const FormFooter = ({ heading, subHeading }) => {
  return (
    <div className={clsx("FormFooter", "text-gray-500")}>
      <h4 className={clsx("heading-md text-center")}>{heading}</h4>
      <div
        className={clsx(
          "text-center",
          "[&>a]:underline-offset-2 text-gray-400 [&>a]:text-gray-500 [&>a]:underline [&>a]:decoration-gray-300 [&>a]:decoration-1",
        )}
      >
        {ReactHtmlParser(subHeading)}
      </div>
    </div>
  );
};

export default FormFooter;
